import React from "react";
import {
  getHeaderStyles,
  getPublicSymbolSize,
  getStyle,
} from "../Common/StylesHelper";
import ProductTagShape from "../Common/ProductTagShape";
import { shapeOptions } from "components/common/TagsShapes/TagsShapes";
import PublicPreviewPriceDisplay from "components/common/PublicPreviewPriceDisplay";

const ProductList = ({
  products = [],
  config,
  styles,
  primaryColor,
  theme = {},
  layoutSettings,
  language,
  currencyInfo,
}) => {
  const { width, height } = getPublicSymbolSize(styles?.productPrice?.size);

  const { listOrder, listLabels, listStyle, headerStyle } =
    layoutSettings?.productList || {};

  const {
    rowSpacing,
    rowBackgroundColor,
    rowBorderColor,
    rowBorderWidth,
    rowBorderRadius,
  } = listStyle || {};

  const cardStyles = {
    background: rowBackgroundColor || "transparent",
    marginTop: Math.max(rowSpacing ?? 0, 30),
    border: `${rowBorderWidth}px solid ${rowBorderColor}`,
    borderRadius: rowBorderRadius,
  };

  const innerItemStyle = {
    border: `${rowBorderWidth}px solid ${rowBorderColor}`,
    borderRadius: rowBorderRadius,
  };

  return (
    <div className="product_list">
      {products?.length > 0 &&
        products.map((product, index) => (
          <div
            className="product_list_wrapper"
            key={product.productId || index}
            style={cardStyles}
          >
            {/* --- Conditionally render Title & Price if in listOrder --- */}
            {(listOrder.includes("productTitle") ||
              listOrder.includes("productPrice")) && (
              <div className="g_between">
                {listOrder.includes("productTitle") && (
                  <h5
                    style={{ ...getStyle(styles, "productTitle") }}
                    className="in_2_line"
                  >
                    {product.productTitle || ""}
                  </h5>
                )}

                {listOrder.includes("productPrice") && (
                  <p
                    className="product-price"
                    style={{
                      ...getStyle(styles, "productPrice"),
                    }}
                  >
                    <PublicPreviewPriceDisplay
                      currencyInfo={currencyInfo}
                      productPrice={product.productPrice}
                      width={width}
                      height={height}
                      primaryColor={
                        styles["productPrice"].color || primaryColor
                      }
                    />
                  </p>
                )}
              </div>
            )}

            {/* --- Render remaining fields from listOrder (excluding title/price) --- */}
            <div className="inner_section" style={innerItemStyle}>
              {listOrder
                .filter(
                  (key) => key !== "productTitle" && key !== "productPrice"
                )
                .map((fieldKey) => {
                  const label = listLabels[fieldKey] || fieldKey;
                  const value = product[fieldKey];

                  return (
                    <div key={fieldKey} className="single_column">
                      {fieldKey === "imageUrl" ||
                      fieldKey === "productDescription" ? (
                        <div className="d-flex gap-3">
                          {/* Only render the image when we encounter imageUrl */}
                          {fieldKey === "imageUrl" ? (
                            <>
                              <div className="d-flex flex-column white-space-nowrap">
                                <p
                                  style={{
                                    ...getHeaderStyles(
                                      headerStyle,
                                      primaryColor
                                    ),
                                  }}
                                >
                                  {listLabels["imageUrl"] || "imageUrl"}:
                                </p>
                                <img
                                  src={value}
                                  alt="Product Preview"
                                  width={120}
                                  height={120}
                                  className="product_img"
                                />
                              </div>
                            </>
                          ) : (
                            <div>
                              <p>
                                <span
                                  style={{
                                    ...getHeaderStyles(
                                      headerStyle,
                                      primaryColor
                                    ),
                                  }}
                                >
                                  {listLabels["productDescription"] ||
                                    "productDescription"}
                                  :
                                </span>{" "}
                                <span
                                  style={{
                                    ...getStyle(styles, "productDescription"),
                                  }}
                                >
                                  {product["productDescription"]}
                                </span>
                              </p>
                            </div>
                          )}
                        </div>
                      ) : fieldKey === "tags" && value ? (
                        <ProductTagShape
                          tags={value}
                          shapeOptions={shapeOptions}
                          styles={styles}
                          primaryColor={primaryColor}
                          width={60}
                          height={60}
                        />
                      ) : fieldKey === "allergens" && Array.isArray(value) ? (
                        <div className="allergens">
                          <h5
                            style={{
                              ...getHeaderStyles(headerStyle, primaryColor),
                            }}
                          >
                            {language === "en" ? "Allergen" : "مسببات الحساسية"}
                          </h5>
                          <div className="inner_section">
                            {value.map((allergen, idx) => (
                              <div
                                key={idx}
                                className="inner_div"
                                style={{
                                  "--theme-primary-color": primaryColor,
                                }}
                              >
                                <img
                                  src={allergen?.url}
                                  width={15}
                                  height={15}
                                  alt=""
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <div className="d-flex gap-1">
                          <p
                            style={{
                              ...getHeaderStyles(headerStyle, primaryColor),
                            }}
                          >
                            {label}:
                          </p>
                          <p
                            style={{
                              ...getStyle(styles, value),
                            }}
                          >
                            {value}
                          </p>
                        </div>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>
        ))}
    </div>
  );
};

export default ProductList;
